// removed by extract-text-webpack-plugin
module.exports = {"label":"_2tPvNhgCALOGvIzrU2KbN2"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite.scss
// module chunks = 0